import { AxiosError } from 'axios';
import { t } from '../i18n';
import type { ApiErrorBody } from '../types/api';

function body(err: unknown): ApiErrorBody['error'] | undefined {
  if (err instanceof AxiosError) {
    const data = err.response?.data as Partial<ApiErrorBody> | undefined;
    return data?.error;
  }
  return undefined;
}

export function errorStatus(err: unknown): number | undefined {
  return err instanceof AxiosError ? err.response?.status : undefined;
}

/** Server messages are translated when the dictionary knows them; otherwise shown as sent (English). */
export function errorMessage(err: unknown): string {
  const b = body(err);
  if (b) return t(b.message);
  if (err instanceof AxiosError && !err.response) return t('Unable to reach the server. Check your connection and try again.');
  return t('Something went wrong. Please try again.');
}

/** Server-side field validation errors keyed by field path. */
export function fieldErrors(err: unknown): Record<string, string> {
  const out: Record<string, string> = {};
  for (const d of body(err)?.details ?? []) out[d.path] ??= t(d.message);
  return out;
}
